import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Discord({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M18.9419 6.17248C17.6279 5.61685 16.2407 5.22267 14.8158 5C14.6208 5.32194 14.4443 5.65318 14.2872 5.99232C12.7694 5.78107 11.2258 5.78107 9.70801 5.99232C9.55079 5.65321 9.37437 5.32198 9.17946 5C7.75361 5.22455 6.3655 5.61966 5.05016 6.17538C2.43887 9.74367 1.73099 13.2233 2.08493 16.6536C3.61417 17.6971 5.32582 18.4908 7.14548 19C7.55522 18.491 7.91778 17.9511 8.22933 17.3858C7.63759 17.1817 7.06646 16.9299 6.52255 16.6333C6.6657 16.5374 6.8057 16.4386 6.94098 16.3427C8.52364 17.0301 10.251 17.3865 12 17.3865C13.7489 17.3865 15.4763 17.0301 17.0589 16.3427C17.1958 16.4458 17.3358 16.5446 17.4774 16.6333C16.9324 16.9304 16.3602 17.1827 15.7675 17.3873C16.0786 17.9523 16.4412 18.4918 16.8513 19C18.6725 18.4928 20.3855 17.6996 21.915 16.655C22.3303 12.677 21.2055 9.22935 18.9419 6.17248ZM8.67765 14.544C7.69134 14.544 6.87649 13.7173 6.87649 12.7003C6.87649 11.6833 7.66302 10.8493 8.6745 10.8493C9.68598 10.8493 10.4945 11.6833 10.4772 12.7003C10.4599 13.7173 9.68284 14.544 8.67765 14.544ZM15.3223 14.544C14.3344 14.544 13.5227 13.7173 13.5227 12.7003C13.5227 11.6833 14.3092 10.8493 15.3223 10.8493C16.3353 10.8493 17.1376 11.6833 17.1203 12.7003C17.103 13.7173 16.3275 14.544 15.3223 14.544Z" fill="currentColor" /></Svg>;
}
export default Discord;